import times from 'lodash-es/times';
import React, { memo } from 'react';
import { List } from '@fourthwall/components';
import { ProductsListItem } from '../ProductsListItem/ProductsListItem';
const MemoizedSkeletonItem = memo(ProductsListItem.Skeleton);
export const LoadingList = memo(({ count }) => (React.createElement(List, { data: times(count, String), bottomBorder: false, renderItem: () => React.createElement(MemoizedSkeletonItem, null) })));
